<template>
  <div :class="{'spl-parcel-detail-block-vertical': vertical, 'spl-parcel-detail-block-error': error, 'spl-parcel-detail-block-editing': isEditing}" class="spl-parcel-detail-block">
    <div class="spl-parcel-detail-block__label">
      {{ label }}
    </div>
    <div
      v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.UPDATE)"
      :class="{'spl-parcel-detail-block__edit-open': isEditing}"
      class="spl-parcel-detail-block__edit"
      @click="toggleEditable" />
    <div class="spl-parcel-detail-block__body">
      <div
        v-for="(item, index) in blockContent"
        :key="'parcelDetailSignedBy' + index"
        :class="{'spl-parcel-detail-block__body__content-blocks': contentBlocks, 'spl-parcel-detail-block__body__content-edit': isEditing}"
        class="spl-parcel-detail-block__body__content">
        <div class="spl-parcel-detail-block__body__content__label">
          {{ item.label }}
        </div>
        <div v-if="!isEditing" class="spl-parcel-detail-block__body__content__value spl-parcel-detail-block__body__content__value-pre">
          {{ item.value }}
        </div>

        <div v-if="isEditing" class="spl-parcel-detail-block__body__content__value">
          <form-input
            v-if="!item.type"
            :value="item.value"
            :index="index"
            @updateInputValue="updateItemValue" />
          <form-textarea
            v-if="item.type === 'textarea'"
            :value="item.value"
            :index="index"
            @updateTextareaValue="updateItemValue" />
        </div>
        <div class="row">
          <img
            v-if="item.signature_picture"
            class="spl-signature-img"
            :src="'data:image/gif;base64,' + item.signature_picture">
          <img v-else-if="getExternalSignatureURL()" :src="getExternalSignatureURL()">
        </div>
      </div>

      <div v-if="isEditing" class="row">
        <div class="col6">
          <form-button
            wide="true"
            secondary="true"
            @onClick="close">
            Cancel
          </form-button>
        </div>
        <div class="col6">
          In the future you will be able to save your changes.
          <!-- Hidden_Feature
                    <form-button wide="true" :buttonCallback="save">Save</form-button>
                  -->
        </div>
      </div>
    </div>
    <div v-if="highlight" class="spl-parcel-detail-block__highlight">
      {{ highlight }}
    </div>
  </div>
</template>

<script>
import Helpers from '@/helpers'
import constants from '@/constants'
export default {
  name: 'ParcelDetailBlock',
  mixins: [Helpers],
  props: [
    'label',
    'highlight',
    'error',
    'content',
    'contentBlocks',
    'vertical',
    'originalParcelJson'
  ],
  data () {
    return {
      tempBlockContent: this.cloneArray(this.content || []),
      isEditing: false,
      constants
    }
  },
  computed: {
    blockContent () {
      return this.content
    }
  },
  methods: {
    close () {
      this.isEditing = false
    },
    save () {
      this.blockContent = this.cloneArray(this.tempBlockContent)
      this.close()
    },
    toggleEditable () {
      this.isEditing = !this.isEditing
    },
    updateItemValue (inputValue, index) {
      if (inputValue.label) inputValue = inputValue.label
      this.tempBlockContent[index].value = inputValue
    },
    /**
     * Gets the external signature image for the parcel
     */
    getExternalSignatureURL () {
      return this.getExternalSignature(this.originalParcelJson, constants)
    }
  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-parcel-detail-block {
        background-color: $parcelTimelineBackgroundColor;
        margin-bottom: 20px;
        padding: 20px 17px 30px 17px;
        position: relative;
        width: 100%;

        @include mobile() {
            padding-bottom: 20px;
        }
        &-error {
            background-color: $redBackgroundLight;
            border-left: 2px solid $red;

            .spl-parcel-detail-block__edit {
                background-image: url(../../assets/icon-tripple-dot-red.svg);

            }
        }
        &-error &__edit {
            &-open {
                background-image: url(../../assets/icon-close-red.svg);
            }
        }
        &-vertical {
            &:after {
                clear: both;
                content: '';
                display: block;
                float: none;
            }
            .spl-parcel-detail-block {
                &__label,
                &__body {
                    float: left;
                    min-height: 10px;
                    vertical-align: top;
                }
                &__label {
                    width: 16.6667%;

                    @include mobile() {
                        width: 100%;
                    }
                }
                &__body {
                    width: 41.6667%;

                    @include mobile() {
                        width: 100%;
                    }
                }
            }
        }
        &__edit {
            background-image: url(../../assets/icon-tripple-dot.svg);
            background-position: center center;
            background-repeat: no-repeat;
            cursor: pointer;
            height: 25px;
            position: absolute;
            right: 10px;
            top: 20px;
            transition: opacity $shortTransition ease-in-out;
            width: 25px;

            &:hover {
                opacity: 0.5;
            }
            &-open {
                background-image: url(../../assets/icon-close.svg);
            }
        }
        &__label {
            color: $mainInputColor;
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 15px;
        }
        &__body {
            .spl-button,
            .spl-textarea,
            .spl-dropdown {
                margin: 0 0 10px 0;
            }
            &__content {
                font-size: 12px;
                line-height: 1.7;

                &:after {
                    clear: both;
                    content: '';
                    display: block;
                    float: none;
                }
                &-blocks,
                &-edit {
                    margin-bottom: -20px;

                    .spl-parcel-detail-block__body__content {
                        &__label,
                        &__value {
                            width: 100%;
                        }
                        &__value {
                            margin-bottom: 20px;
                        }
                    }
                }
                &-edit .spl-parcel-detail-block__body__content {
                    &__label {
                        color: $parcelDetailBlockLabelColor;
                        font-family: $mono;
                        font-size: 9px;
                        font-weight: 700;
                        line-height: 12px;
                        letter-spacing: 1px;
                        margin-bottom: 10px;
                        text-transform: uppercase;
                    }
                    &__value {
                        .spl-input {
                            margin-bottom: 10px;
                        }
                    }
                }
                &__label,
                &__value {
                    float: left;
                    min-height: 10px;
                    vertical-align: top;
                    width: 50%;

                    @include mobile() {
                        width: 100%;
                    }
                }
                &__value {
                    font-weight: 600;

                    &-pre {
                        white-space: pre;
                    }
                    @include mobile() {
                        margin-bottom: 10px;
                    }
                }
            }
        }
        &__highlight {
            background-color: $tableRowBackgroundColorSelected;
            border-left: 2px solid $middleYellow;
            bottom: 0;
            color: $mainInputColor;
            font-size: 12px;
            font-weight: 400;
            margin: 30px -17px -30px -17px;
            padding: 15px;
        }
    }
    .spl-signature-img {
      width: 95%;
    }
</style>
